import { CSSProperties, ReactNode } from 'react';

interface RiseProps {
  delay?: number;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

export default function Rise({ delay = 0, className, style, children }: RiseProps) {
  return (
    <div
      className={['vara2-rise', className].filter(Boolean).join(' ')}
      style={{ animationDelay: `${delay}ms`, ...style }}
    >
      {children}
    </div>
  );
}
